import { render, staticRenderFns } from "./notes-detail.vue?vue&type=template&id=741ffb42&scoped=true&"
import script from "./notes-detail.vue?vue&type=script&lang=js&"
export * from "./notes-detail.vue?vue&type=script&lang=js&"
import style0 from "./notes-detail.vue?vue&type=style&index=0&id=741ffb42&scoped=true&lang=scss&"
import style1 from "./notes-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ffb42",
  null
  
)

export default component.exports